import { CountryCodes, Home, HomeTier, LpsDolsSetting } from '@lmc/ts-common'
import { useSelector } from 'react-redux'

const useHomeType = () => {
  const isPro =
    useSelector(
      (state: { global: { home: Home } }) =>
        state?.global?.home?.features?.pro?.enabled
    ) || false

  const isEmar =
    useSelector(
      (state: { global: { home: Home } }) =>
        state?.global?.home?.features?.eMAR?.enabled
    ) || false

  const isFromScotlandOrWales = useSelector(
    (state: { global: { home: Home } }) =>
      state?.global?.home?.countryCode === CountryCodes.sct ||
      state?.global?.home?.countryCode === CountryCodes.wls
  )

  const isFromCanada = useSelector(
    (state: { global: { home: Home } }) =>
      state?.global?.home?.countryCode === CountryCodes.ca
  )

  const hasRota = useSelector(
    (state: { global: { home: Home } }) =>
      state?.global?.home?.features?.rota?.enabled
  )

  const alreadyHadRotaTrialEnabled = !!useSelector(
    (state: { global: { home: Home } }) => state?.global?.home?.rotaTrialDate
  )

  const isDoLSOverride = useSelector(
    (state: { global: { home: Home } }) =>
      state?.global?.home?.preferredServiceName === LpsDolsSetting.dols
  )

  const isMultiSiteHome = useSelector(
    (state: { global: { home: Home } }) =>
      state?.global?.home?.features?.isMultiSiteHome?.enabled
  )

  const features = useSelector(
    (state: { global: { home: Home } }) => state?.global?.home?.features
  )

  const isOutstanding = useSelector(
    (state: { global: { home: Home } }) =>
      state?.global?.home?.tier === HomeTier.outstanding
  )

  return {
    isPro,
    isEmar,
    isFromScotlandOrWales,
    isFromCanada,
    isDoLSOverride,
    hasRota,
    alreadyHadRotaTrialEnabled,
    features,
    isMultiSiteHome,
    isOutstanding
  }
}

export default useHomeType
